import { useEffect } from 'react'

import { useActions } from '../../../draft-trades/store/use-actions'
import { actions as rawActions } from '../../../tradebuilder-v2/modules/03-portfolio/state/portfolio-slice'
import { PortfolioStepStateless } from '../../../tradebuilder-v2/modules/03-portfolio/templates'
import { useAppSelector } from '../../../tradebuilder-v2/store/hooks'

export const TradeEditPortfolioStep = () => {
  const state = useAppSelector(state => state.portfolio)
  const builderState = useAppSelector(state => state.builder)
  const actions = useActions(rawActions)
  useEffect(() => {
    actions.init(builderState.note)
  }, [actions, builderState.note])

  const onSaveAndContinue = () => {
    actions.updateAndMoveNext()
  }
  const onMoveBack = () => {
    actions.moveBack()
  }

  return (
    <PortfolioStepStateless
      actions={actions}
      state={state}
      onMoveBack={onMoveBack}
      onSaveAndContinue={onSaveAndContinue}
    />
  )
}
